import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';
const testimonials = [{
  name: 'Camila',
  age: 23,
  text: 'Los libros son excelentes. Están muy bien armados, las ilustraciones son hermosas y cada caso te engancha desde la primera pista.'
}, {
  name: 'Tomás',
  age: 28,
  text: 'Superó mis expectativas. Sopicidios es adictivo y El Asesino No Es Sofía es una locura: nunca vi un caso tan bien pensado.'
}, {
  name: 'Sofía',
  age: 19,
  text: 'La calidad es impresionante. Se leen perfecto en el celular y las soluciones están explicadas para entender dónde te equivocaste.'
}, {
  name: 'Martina',
  age: 31,
  text: 'Murdoku es mi favorito. Los acertijos están muy bien graduados: arrancás fácil y de repente estás anotando posibilidades en una hoja.'
}, {
  name: 'Agustín',
  age: 34,
  text: 'Viaje al Pasado está buenísimo, cada época tiene su propio clima. Son libros que dan ganas de resolver de nuevo.'
}, {
  name: 'Julieta',
  age: 26,
  text: 'Los seis libros valen muchísimo la pena. Se ve que están cuidados al detalle, no hay ninguno de relleno.'
}];
export const TestimonialCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => {
    setCurrentIndex(prev => (prev + 1) % testimonials.length);
  };
  const prev = () => {
    setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  };
  return <div className="relative max-w-4xl mx-auto px-12" data-id="element-187" data-mp="2l8h7om72d81k">
      <button onClick={prev} aria-label="Testimonio anterior" className="absolute left-0 top-1/2 -translate-y-1/2 bg-white p-2 rounded-full shadow-md text-[#5E1A8A] hover:bg-[#F97316] hover:text-white transition-colors z-10" data-id="element-188" data-mp="2gaxsnk2jkr8k">
        <ChevronLeft size={24} data-id="element-189" data-mp="26fnq8v88ehu9" />
      </button>

      <div className="overflow-hidden py-4" data-id="element-190" data-mp="9lj52b728m1k">
        <AnimatePresence mode="wait" data-id="element-191" data-mp="9khr9yyntlg5">
          <motion.div key={currentIndex} initial={{
          opacity: 0,
          x: 50
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: -50
        }} transition={{
          duration: 0.3
        }} className="bg-white p-6 md:p-8 rounded-2xl shadow-lg border-t-4 border-[#F97316]" data-id="element-192" data-mp="4mg1ywan4pw8">
            <div className="flex items-center gap-4 mb-4" data-id="element-193" data-mp="1p61x3bzqiu04">
              <div className="w-12 h-12 bg-[#5E1A8A] rounded-full flex items-center justify-center text-white font-bold text-xl shrink-0" data-id="element-194" data-mp="1u2jzi57leg9a">
                {testimonials[currentIndex].name.charAt(0)}
              </div>
              <div data-id="element-195" data-mp="2mqo74w9q53em">
                <h4 className="font-heading font-bold text-lg text-[#1E1E1E]" data-id="element-196" data-mp="2mr7nw9nn1lr2">
                  {testimonials[currentIndex].name},{' '}
                  {testimonials[currentIndex].age} años
                </h4>
                <div className="flex text-[#F97316]" data-id="element-197" data-mp="2cvw5nhd0twek">
                  {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-198" data-mp="xbri948xai5x" data-mpi={i} />)}
                </div>
              </div>
            </div>
            <p className="text-gray-700 italic text-lg leading-relaxed" data-id="element-199" data-mp="11cbg6a1blpt4">
              "{testimonials[currentIndex].text}"
            </p>
          </motion.div>
        </AnimatePresence>
      </div>

      <button onClick={next} aria-label="Testimonio siguiente" className="absolute right-0 top-1/2 -translate-y-1/2 bg-white p-2 rounded-full shadow-md text-[#5E1A8A] hover:bg-[#F97316] hover:text-white transition-colors z-10" data-id="element-200" data-mp="oyelsrx0reu8">
        <ChevronRight size={24} data-id="element-201" data-mp="b44773eql11w" />
      </button>

      <div className="flex justify-center gap-2 mt-6" data-id="element-202" data-mp="b4x4ldrt2e7d">
        {testimonials.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} aria-label={`Ver testimonio ${idx + 1}`} className={`w-2.5 h-2.5 rounded-full transition-colors ${idx === currentIndex ? 'bg-[#F97316]' : 'bg-gray-300'}`} data-id="element-203" data-mp="6741wuppo2bu" data-mpi={idx} />)}
      </div>
    </div>;
};